import { scriptLoader } from './scriptLoader';

const setup = () => {
  if (['production', 'staging'].includes(process.env.A2B_ENV)) {
    scriptLoader(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  }
};

export default setup;
